import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./AccountBook.scss";
import Cookies from "universal-cookie";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


class AccountBook extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.city_name = this.cookies.get("city_name");
    this.city_id = this.cookies.get("city_id");
    this.student_is_manager = this.cookies.get("student_is_manager");

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;

    this.state = {
      metricsJSON: "",
      nowCosts: [],
      nowRevenue: [],
      everythingTable: [],
    };
  }



  render() {
    return (
      <div className={`${this.props.display === "show" ? "active" : "hidden"}`}>
        <ReactCSSTransitionGroup
          transitionName="fade"
          transitionAppear={true}
          transitionAppearTimeout={500}
          transitionEnterTimeout={500}
          transitionLeaveTimeout={300}
        >
          <div className="accountModal">
            <div className="accountModal-content">
              <table id="accountBook">
                <thead>
                  <tr>
                    <th className="headerClass">
                      Description{" "}
                      <div className="sortIcons">
                        {" "}
                        <FontAwesomeIcon
                          icon={["fas", "sort-up"]}
                          style={{ color: "white" }}
                          onClick={e => this.props.onSortUp(e, "description")}
                        />
                        <FontAwesomeIcon
                          icon={["fas", "sort-down"]}
                          style={{ color: "white" }}
                          onClick={e => this.props.onSortDown(e, "description")}
                        />
                      </div>
                    </th>
                    <th className="headerClass">
                      District{" "}
                      <div className="sortIcons">
                        {" "}
                      </div>
                    </th>
                    <th className="headerClass">
                      {sessionStorage.getItem("previous_year") - 1 === 2017
                        ? 2018
                        : sessionStorage.getItem("previous_year") - 1}{" "}
                      <div className="sortIcons">
                        {" "}
                      </div>
                    </th>
                    <th className="headerClass">
                      {parseInt(sessionStorage.getItem("previous_year")) === 2018
                        ? null
                        : sessionStorage.getItem("previous_year")}{" "}
                      <div className="sortIcons">
                        {" "}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.everythingTable
                    ? this.props.everythingTable.sort().map((item, index) => (
                        <tr key={index} className="accountBookTableRow">
                          <td className="accountBookTableItems">
                            {Object.keys(item)}
                          </td>
                          <td>
                            <table id="accountBookChildren">
                              <tbody>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].City ? (
                                    <td className="accountBookTableData">
                                      City
                                    </td>
                                  ) : null}
                                </tr>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].Corbusville ? (
                                    <td className="accountBookTableData">
                                      Corbusville
                                    </td>
                                  ) : null}
                                </tr>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].Downtown ? (
                                    <td className="accountBookTableData">
                                      Downtown
                                    </td>
                                  ) : null}
                                </tr>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].HowardGardens ? (
                                    <td className="accountBookTableData">
                                      Howard Gardens
                                    </td>
                                  ) : null}
                                </tr>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].JacobsHill ? (
                                    <td className="accountBookTableData">
                                      Jacobs Hill
                                    </td>
                                  ) : null}
                                </tr>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].MosesGulch ? (
                                    <td className="accountBookTableData">
                                      Moses Gulch
                                    </td>
                                  ) : null}
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td>
                            <table id="accountBookChildren">
                              <tbody>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].City ? (
                                    <td className="accountBookTableData">
                                      ${" "}
                                      {item[
                                        Object.keys(item)
                                      ][0].City.toString().replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ","
                                      )}
                                    </td>
                                  ) : null}
                                </tr>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].Corbusville ? (
                                    <td className="accountBookTableData">
                                      ${" "}
                                      {item[
                                        Object.keys(item)
                                      ][0].Corbusville.toString().replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ","
                                      )}
                                    </td>
                                  ) : null}
                                </tr>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].Downtown ? (
                                    <td className="accountBookTableData">
                                      ${" "}
                                      {item[
                                        Object.keys(item)
                                      ][0].Downtown.toString().replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ","
                                      )}
                                    </td>
                                  ) : null}
                                </tr>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].HowardGardens ? (
                                    <td className="accountBookTableData">
                                      ${" "}
                                      {item[
                                        Object.keys(item)
                                      ][0].HowardGardens.toString().replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ","
                                      )}
                                    </td>
                                  ) : null}
                                </tr>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].JacobsHill ? (
                                    <td className="accountBookTableData">
                                      ${" "}
                                      {item[
                                        Object.keys(item)
                                      ][0].JacobsHill.toString().replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ","
                                      )}
                                    </td>
                                  ) : null}
                                </tr>
                                <tr className="accountBookTableRow">
                                  {item[Object.keys(item)][0].MosesGulch ? (
                                    <td className="accountBookTableData">
                                      ${" "}
                                      {item[
                                        Object.keys(item)
                                      ][0].MosesGulch.toString().replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        ","
                                      )}
                                    </td>
                                  ) : null}
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td>
                            {item[Object.keys(item)][1] ? (
                              <table id="accountBookChildren">
                                <tbody>
                                  <tr className="accountBookTableRow">
                                    {item[Object.keys(item)][1].City ? (
                                      <td className="accountBookTableData">
                                        ${" "}
                                        {item[
                                          Object.keys(item)
                                        ][1].City.toString().replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        )}
                                      </td>
                                    ) : null}
                                  </tr>
                                  <tr className="accountBookTableRow">
                                    {item[Object.keys(item)][1].Corbusville ? (
                                      <td className="accountBookTableData">
                                        ${" "}
                                        {item[
                                          Object.keys(item)
                                        ][1].Corbusville.toString().replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        )}
                                      </td>
                                    ) : null}
                                  </tr>
                                  <tr className="accountBookTableRow">
                                    {item[Object.keys(item)][1].Downtown ? (
                                      <td className="accountBookTableData">
                                        ${" "}
                                        {item[
                                          Object.keys(item)
                                        ][1].Downtown.toString().replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        )}
                                      </td>
                                    ) : null}
                                  </tr>
                                  <tr className="accountBookTableRow">
                                    {item[Object.keys(item)][1]
                                      .HowardGardens ? (
                                      <td className="accountBookTableData">
                                        ${" "}
                                        {item[
                                          Object.keys(item)
                                        ][1].HowardGardens.toString().replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        )}
                                      </td>
                                    ) : null}
                                  </tr>
                                  <tr className="accountBookTableRow">
                                    {item[Object.keys(item)][1].JacobsHill ? (
                                      <td className="accountBookTableData">
                                        ${" "}
                                        {item[
                                          Object.keys(item)
                                        ][1].JacobsHill.toString().replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        )}
                                      </td>
                                    ) : null}
                                  </tr>
                                  <tr className="accountBookTableRow">
                                    {item[Object.keys(item)][1].MosesGulch ? (
                                      <td className="accountBookTableData">
                                        ${" "}
                                        {item[
                                          Object.keys(item)
                                        ][1].MosesGulch.toString().replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        )}
                                      </td>
                                    ) : null}
                                  </tr>
                                </tbody>
                              </table>
                            ) : null}
                          </td>
                        </tr>
                      ))
                    : null}
                </tbody>
              </table>
              <span className="close" onClick={this.props.closeModal}>
                &times;
              </span>
            </div>
          </div>
        </ReactCSSTransitionGroup>
      </div>
    );
  }
}

export default withRouter(AccountBook);
